import React from "react";
import { Modal } from "../../../components";
import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import { useOpenNewContactSidePanel } from "components/SidePanel/contact/NewContactSidePanel";

interface Props {
  company: server.dto.Company
  onClose: (hasChanged: boolean) => void
  excludeKeys: number[]
}

const AddNewModal = (props: Props) => {
  const openNewContactSidePanel = useOpenNewContactSidePanel();
  const [displaySelectContactModal, setDisplaySelectContactModal] = React.useState(false);

  const onContactCreated = async (contact: server.dto.Contact) => {
    const res = await window.CoreApi.CompanyToContact.SetLink({
      companyId: props.company.companyId,
      contactId: contact.contactId,
      isActive: true
    });

    if (res.data.hasErrors) {
      window.displayGenericModal("Error", res.data.errors[0].message, "tiny", "red");
      return;
    }

    props.onClose(true);
  }

  const onContactSelected = async (contact: server.dto.ContactSmallV2) => {
    const res = await window.CoreApi.CompanyToContact.SetLink({
      companyId: props.company.companyId,
      contactId: contact.contactId,
      isActive: true
    });

    if (res.data.hasErrors) {
      window.displayGenericModal("Error", res.data.errors[0].message, "tiny", "red");
      return;
    }

    props.onClose(true);
  };

  return <>
    <Modal
      title={""}
      style={{ width: 350 }}
      displayHeader={false}
      isOpen
      gap="regular"
      handleClose={() => { props.onClose(false); }}
    >
      <ButtonPrimary
        onClick={() => {
          props.onClose(false);
          openNewContactSidePanel({ onCreated: contact => onContactCreated(contact) });
        }}
        label={RESX.Contact.NewContactPerson}
      />

      <ButtonSecondary
        onClick={() => { setDisplaySelectContactModal(true); }}
        label={RESX.Contact.LinkExistingContact}
      />
    </Modal>

    {displaySelectContactModal && <ContactModalPicker
      canCreateNew={false}
      nonInPageEditing={{
        onChange: onContactSelected,
        startOpen: true,
        value: undefined,
        required: false,
        validatorKey: "contactModalPicker",
      }}
    />}
  </>;
};

export default AddNewModal;